import { jsx as x } from "react/jsx-runtime";
import { useState as _, useCallback as V, useMemo as H, useEffect as O, useLayoutEffect as C } from "react";
import { usePrevState as R, sendAnalyticEvent as U } from "@perxis-auto/shared";
import { useApp as B, useConfig as D, useCurrentStage as F } from "@perxis-auto/trade-in-sdk";
import { ANALYTIC_EVENT_RESET_RESULT as I, BUTTON_ID_RESET_FORM as M, EVENT_BUTTON_CLICKED as b, EVENTS_CHANNEL as S } from "../../../shared/config/events.js";
import { AppContext as j } from "../../../shared/lib/app/context/appContext.js";
import { withTradeInProvider as k } from "../../../shared/lib/app/hoc/withTradeInProvider.js";
import { sendEvent as w } from "../../../shared/lib/event/sendEvent.js";
function K({ apiRoot: o, clientId: n, language: u, iconSet: d, eventsHandler: p, children: N }) {
  const {
    actions: { reset: a }
  } = B(), { actions: L } = D(), { setApiRoot: f, setClientId: m } = L, { data: t } = F(), e = R(t), [s, i] = _([]), [h, y] = _({}), { onSuccess: E, onFailure: l, onReset: c } = h, v = V(() => (a(), i([]), w(b, { id: M }, I), c == null ? void 0 : c()), [c, a]), g = H(
    () => ({
      apiRoot: o,
      clientId: n,
      language: u,
      iconSet: d,
      prevStage: s.length ? s[s.length - 1] : null,
      onSuccess: E,
      onFailure: l,
      onReset: v,
      setAppHandlers: y
    }),
    [o, n, u, d, s, E, l, v]
  );
  O(() => {
    if (!t) {
      i([]);
      return;
    }
    if (!(!e || e.id === t.id)) {
      if (e.success === t.id || e.error === t.id || e.go_to === t.id) {
        i((r) => [...r, e]);
        return;
      }
      i((r) => r.slice(0, -1));
    }
  }, [t == null ? void 0 : t.id]);
  const T = (r) => {
    const { type: P, analytic: A } = r.detail || {};
    A && U(A), p && p(P, r.detail);
  };
  return C(() => (document.addEventListener(S, T), () => {
    document.removeEventListener(S, T);
  }), []), C(() => {
    f(o), m(n);
  }, [o, n, f, m]), /* @__PURE__ */ x(j.Provider, { value: g, children: N });
}
const Z = k(K);
export {
  Z as AppProvider
};
